import { SelectContent, SelectTrigger, SelectGroup, SelectValue, SelectItem, Select } from '@/components/ui';
import { DataTablePageSizeEnum } from '@/enums';
import { getSelectOptions } from '@/functions';

type TProps = {
  onChange: (limit?: number) => void;
  limit?: number;
}

export const DataTablePaginationPageSize = ({ limit = DataTablePageSizeEnum._50, onChange }: TProps) => {

  const optionsDataTablePageSizeEnum = getSelectOptions('DataTablePageSizeEnum');

  const handleOnValueChange = (value: string) => {
    const intValue = parseInt(value);
    onChange(intValue <= 0 ? undefined : intValue);
  };

  return <></>;

  return (
    <div className='flex items-center space-x-3 me-5'>
      <div className='w-10'>
        <Select
          value={limit.toString()}
          onValueChange={handleOnValueChange}>
          <SelectTrigger className='h-8 w-auto space-x-2 me-52'>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {
                optionsDataTablePageSizeEnum
                  .map(
                    l => (
                      <SelectItem
                        key={l.value}
                        className='cursor-pointer'
                        value={(l.value ?? '').toString()}>
                        {l.title}
                      </SelectItem>
                    )
                  )
              }
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  );

};

export default DataTablePaginationPageSize;
